import * as React from 'react';
import { StarryUIIcon } from '../components/StarryUIIcon';

export const CaretLeft = ({ color = 'currentColor', ...icon }: image.IStarryUIIcon) => (
    <StarryUIIcon {...icon}>
        <path
            fill={color}
            d="M13.9821429,16.5892857 C13.8177075,16.5892857 13.6754098,16.5292045 13.5552455,16.4090402 L9.30524554,12.1590402 C9.18508124,12.0388759 9.125,11.8965782 9.125,11.7321429 C9.125,11.5677075 9.18508124,11.4254098 9.30524554,11.3052455 L13.5552455,7.05524554 C13.6754098,6.93508124 13.8177075,6.875 13.9821429,6.875 C14.1465782,6.875 14.2888759,6.93508124 14.4090402,7.05524554 C14.5292045,7.17540983 14.5892857,7.31770751 14.5892857,7.48214286 L14.5892857,15.9821429 C14.5892857,16.1465782 14.5292045,16.2888759 14.4090402,16.4090402 C14.2888759,16.5292045 14.1465782,16.5892857 13.9821429,16.5892857 Z"
        />
    </StarryUIIcon>
);
